export const BLANK_PARTY_SERVICE_UPDATE = {
  value: '',
  isValid: false,
  name: '',
  canopusId: '',
} as const;

export const isBlankPartyIdValue = (partyId: unknown): boolean => {
  if (partyId === null || partyId === undefined) {
    return true;
  }
  return `${partyId}`.trim() === '';
};

export const canPersistBlankPartyIdClear = (
  partyId: unknown,
  partyIdRequired: boolean | undefined
): boolean => isBlankPartyIdValue(partyId) && partyIdRequired !== true;
